import applyAddonConfig from 'uniba-volto-manutenzione/config/config.js';

const applyConfig = (config) => {
  return applyAddonConfig(config);
};

export default applyConfig;
